import { mergeWith } from 'lodash';

export function deepMerge<T>(a: T, b: Partial<T>): T {
  return mergeWith({}, a, b, (a, b) =>
    Array.isArray(a) && Array.isArray(b) ? b : undefined,
  );
}
